import { defineMessages } from 'react-intl';

export default defineMessages({
  postgres_couch: {
    id: 'postgres_couch.title',
    defaultMessage: 'Couch',
  },
  couch_postgres: {
    id: 'couch_postgres.title',
    defaultMessage: 'Postgres',
  },
  postgres_netsuite: {
    id: 'postgres_netsuite.title',
    defaultMessage: 'Netsuite',
  },
})